import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * @copyright Schweizerische Bundesbahnen SBB
 * @class ListViewNotifyService
 * @version 0.0.1
 * @since Januar 2018
 * @description The DetailViewNotifyService provides all features for usage in components.
 */
@Injectable({
  providedIn: 'root',
})
export class DetailViewNotifyService {
  // Notify detailView to close
  public closeSubject: Subject<any>;
  // Notify when feature are created
  public featureCreatedSubject: Subject<any>;
  // Notify when feature creation is canceled
  public featureCreationCanceledSubject: Subject<any>;
  // Notify data-table resized Subject für alle features-table
  public onFeatureSavedSubject: Subject<any>;
  // Notify when feature is validated
  public validateFeatureSubject: Subject<any>;
  // Notify when Detailview expanded
  public onDetailViewExpandSubject: Subject<boolean>;
  // Notify related table has been clicked
  public onRelatedTableTabClickedSubject: Subject<number>;
  public onCheckSAPIdSuccessSubject: Subject<any>;
  public onChangeVerkaufsObjectLinieNrSubject: Subject<any>;
  public onSetTransObjektArtSubject: Subject<string>;
  public onUpdatePatchGraphicFormValuesSubject: Subject<any>;

  constructor() {
    this.closeSubject = new Subject();
    this.featureCreatedSubject = new Subject();
    this.featureCreationCanceledSubject = new Subject();
    this.onFeatureSavedSubject = new Subject();
    this.validateFeatureSubject = new Subject();
    this.onDetailViewExpandSubject = new Subject();
    this.onRelatedTableTabClickedSubject = new Subject();
    this.onCheckSAPIdSuccessSubject = new Subject();
    this.onChangeVerkaufsObjectLinieNrSubject = new Subject();
    this.onUpdatePatchGraphicFormValuesSubject = new Subject();
    this.onSetTransObjektArtSubject = new Subject();
  }
}
